import type { TicketStatus, TicketPriority } from '@/types'

type BadgeVariant =
  | 'default'
  | 'secondary'
  | 'destructive'
  | 'outline'
  | 'success'
  | 'warning'
  | 'info'
  | 'escalated'

export const ticketStatusVariants: Record<TicketStatus, BadgeVariant> = {
  New: 'default',
  Open: 'warning',
  Pending: 'destructive',
  'On Hold': 'outline',
  Escalated: 'escalated',
  Resolved: 'success',
  Closed: 'info',
}

export const ticketPriorityVariants: Record<TicketPriority, BadgeVariant> = {
  Low: 'secondary',
  Medium: 'default',
  High: 'warning',
  Urgent: 'destructive',
}
